import React from 'react';
import {connect} from 'react-redux';
import {GeneralContent} from '../Redux/ContentfulContentGrabber';
import '../CSS/App.css';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import scrollToComponent from "react-scroll-to-component";

class ScrollUpComponent extends React.Component {

    //Fetches content from Contentful before this component mounts
    componentWillMount() {
        this.props.fetchData();
    }

    //When user clicks the header, website scrolls to the top of the page
    clickedScrollUpButton(e) {
        let body = document.body,
            html = document.documentElement;

        let height = Math.max(body.scrollHeight, body.offsetHeight,
            html.clientHeight, html.scrollHeight, html.offsetHeight);

        e.preventDefault();
        scrollToComponent(this.header, {offset: -height, align: 'top', duration: 750});
    }

    //Checks to see if contentful content has returned data yet
    isContentfulContentAvailableYet() {
        return !Array.isArray(this.props.generalContent);
    }

    getScrollUpButtonImgURL() {
        return this.props.generalContent.items[0].fields.scrollUp.fields.file.url;
    }

    render() {
        let scrollUpHTML = [];
        if (this.isContentfulContentAvailableYet()) {
            let scrollUp = this.getScrollUpButtonImgURL();
            scrollUpHTML.push(
                <section className=" scrollUpDiv" ref={(section) => {
                    this.header = section;
                }}>
                    <a>
                        <ReactCSSTransitionGroup
                            transitionName="example"
                            transitionAppear={true}
                            transitionAppearTimeout={50000}
                            transitionEnter={false}
                            transitionLeave={false}>
                        <img src={scrollUp} onClick={this.clickedScrollUpButton.bind(this)} className="scrollUp"
                             draggable="false" alt="Status"/>
                        </ReactCSSTransitionGroup>
                    </a>
                </section>
            );
        }

        return (
            <div>
                {scrollUpHTML}
            </div>
        );
    }
}

//Redux, gathers all Contentful Data
const mapStateToProps = (state) => {
    return {
        generalContent: state.generalContent,
        hasErrored: state.itemsHasErrored,
        isLoading: state.itemsIsLoading
    };
};

//Redux, gathers all Contentful Data
const mapDispatchToProps = (dispatch) => {
    return {
        fetchData: () => dispatch(GeneralContent())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ScrollUpComponent);



// WEBPACK FOOTER //
// ./src/Components/ScrollUpComponent.js